<template>
    <modal
        v-if="show"
        type="is-primary"
        size="is-xmiddle"
        :title="titleModal"
        :submit-text="textSubmit"
        :submit-disabled="!totalContactsToBroadcast"
        :cancel-text="textCancel"
        @submit="submit"
        @closed="closed"
    >
        <filter-container
            :name="name"
            :dropdownClass="dropdownClass"
            :loading="loading"
            :filtersList="filtersList"
            :filtersData="filtersData"
            :loadingSend="loadingSend"
            :isFilterEmpty="isFilterEmpty"
            :hasModal="hasModal"
            :form="form"
            :totalContactsToBroadcast="totalContactsToBroadcast"
            :disableScroll="disableScroll"
            :typeSegment="typeSegment"
            :chooseFilter="chooseFilter"
            :isFirstFilterIntegration="isFirstFilterIntegration"
            @clear="clear"
            @remove-filter="removeFilter"
            @add-filter="addFilter"
            @add-list="addList"
            @apply-filter="applyFilter"
            @change-value-filter="changeValueFilter"
            @filter-selected="filterSelected"
            @handle-open-save-segment-modal="handleOpenSaveSegmentModal"
            @handle-change-type-segment="handleChangeTypeSegment"
            @handle-change-loading-send="handleChangeLoadingSend"
        />
    </modal>
</template>

<script>
import FilterContainer from './FilterContainer';

export default {
    components: {
        FilterContainer,
    },

    props: {
        dropdownClass: { type: String, default: '' },
        form: { type: Object },
        show: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        filtersList: { type: Array },
        filtersData: { type: Object },
        chooseFilter: { type: Object },
        loadingSend: { type: Boolean, default: false },
        isFilterEmpty: { type: Boolean, default: false },
        disableScroll: { type: Boolean, default: false },
        hasModal: { type: Boolean, default: false },
        isFirstFilterIntegration: { type: Boolean, default: false },
        typeSegment: { type: String, default: 'create' },
        totalContactsToBroadcast: { type: Number },
        filterSelected: { type: Number },
        name: { type: String, default: '' },
    },

    emits: ['changeValueFilter', 'clear', 'removeFilter', 'addFilter', 'addList', 'applyFilter', 'closed', 'handleOpenSaveSegmentModal', 'handleChangeTypeSegment', 'handleChangeLoadingSend'],

    computed: {
        titleModal() {
            if (this.chooseFilter) {
                return `Segment – ${this.chooseFilter.name}`;
            } else {
                return 'Recipient criteria';
            }
        },

        textSubmit() {
            return 'Select these contacts';
        },

        textCancel() {
            return 'Clear All';
        },
    },

    methods: {
        changeValueFilter(filter) {
            this.$emit('changeValueFilter', filter);
        },

        clear(data) {
            this.$emit('clear', data);
        },

        removeFilter(data) {
            this.$emit('removeFilter', data);
        },

        addFilter(data) {
            this.$emit('addFilter', data);
        },

        addList() {
            this.$emit('addList');
        },

        applyFilter() {
            this.$emit('applyFilter');
        },

        closed(type) {
            if (type === 'button') {
                this.$rootEvents.$emit('checkIsFirstFilterIntegration', false);
                this.$emit('clear', { status: true });
                this.$emit('closed', false, false);
            } else {
                this.$emit('closed', false, false);
            }
        },

        submit() {
            this.$emit('applyFilter');

            this.filtersList[0][0].name === 'integrations'
                ? this.$emit('closed', false, true)
                : this.$emit('closed', false, false);
        },

        handleOpenSaveSegmentModal(status) {
            this.$emit('handleOpenSaveSegmentModal', status);
        },

        handleChangeTypeSegment(type) {
            this.$emit('handleChangeTypeSegment', type);
        },

        handleChangeLoadingSend(status) {
            this.$emit('handleChangeLoadingSend', status);
        },
    },
};
</script>
